import script from "./GeneSNVTable.vue?vue&type=script&lang=js"
export * from "./GeneSNVTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__